import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { Vegobjekttype } from '@/domain/vegobjekter/Vegobjekttype';
import { ColorIndex, resolveColor } from '@/utils/ColorHelper';

import { VegobjekttypeState } from '@/state';
import {
    resetAllCategoryColors,
    resetVegobjekttypeColor,
    setAllCategoryColors,
    setVegobjekttypeColor,
    toggleVegobjekttypeVisibility,
} from '@/actions/vegobjekterActions';
import { VegobjekttypeColorMenu } from './VegobjekttypeColorMenu';
import '../../../stylesheets/5_components/limiter/what/WhatInfo.less';
interface TagProps {
    vegobjekttype: Vegobjekttype;
    vegobjekttypeData: VegobjekttypeState;
    farge: ColorIndex;
}

interface Props extends TagProps {
    doToggleVegobjekttypeVisibility: (votState: VegobjekttypeState) => void;
    doSetVegobjekttypeColor: (
        votState: VegobjekttypeState,
        color: ColorIndex,
        saveAsDefault?: boolean
    ) => void;
    doResetVegobjekttypeColor: (votState: VegobjekttypeState) => void;
    doSetAllCategoryColors: (votState: VegobjekttypeState, color: ColorIndex) => void;
    doResetAllCategoryColors: (votState: VegobjekttypeState) => void;
}

const mapDispatchToProps = {
    doToggleVegobjekttypeVisibility: toggleVegobjekttypeVisibility,
    doSetVegobjekttypeColor: setVegobjekttypeColor,
    doResetVegobjekttypeColor: resetVegobjekttypeColor,
    doSetAllCategoryColors: setAllCategoryColors,
    doResetAllCategoryColors: resetAllCategoryColors,
};

const HvaInfoComponent: React.FC<Props> = ({
    vegobjekttype,
    vegobjekttypeData,
    farge,
    doToggleVegobjekttypeVisibility,
    doSetVegobjekttypeColor,
    doResetVegobjekttypeColor,
    doSetAllCategoryColors,
    doResetAllCategoryColors,
}) => {
    const { visible } = vegobjekttypeData;
    const visibilityIcon = vegobjekttype.isLine() ? 'timeline' : 'room';
    const iconColor = visible ? resolveColor(farge) : '#c6c6c6';
    // Kept separate from `isColorMenuOpen` so the menu's position doesn't jump to (0, 0)
    // while it is still animating out after being closed.
    const [colorMenuAnchor, setColorMenuAnchor] = useState<{ x: number; y: number }>({
        x: 0,
        y: 0,
    });
    const [isColorMenuOpen, setIsColorMenuOpen] = useState(false);

    return (
        <div className="c-hva-info__leading">
            <button
                className="material-icons c-hva-info__visible"
                type="button"
                onClick={() => doToggleVegobjekttypeVisibility(vegobjekttypeData)}
                onContextMenu={e => {
                    e.preventDefault();
                    setColorMenuAnchor({ x: e.clientX, y: e.clientY });
                    setIsColorMenuOpen(true);
                }}
                style={{ color: iconColor }}
                title={`Vis vegobjekttype ${vegobjekttype.navn} i kart. Høyreklikk for å endre farge.`}
                aria-pressed={vegobjekttypeData.visible}
            >
                {visibilityIcon}
            </button>
            <VegobjekttypeColorMenu
                vegobjekttype={vegobjekttype}
                vegobjekttypeData={vegobjekttypeData}
                anchorPoint={colorMenuAnchor}
                isOpen={isColorMenuOpen}
                onClose={() => setIsColorMenuOpen(false)}
                onSetVegobjekttypeColor={doSetVegobjekttypeColor}
                onResetVegobjekttypeColor={doResetVegobjekttypeColor}
                onSetAllCategoryColors={doSetAllCategoryColors}
                onResetAllCategoryColors={doResetAllCategoryColors}
            />
        </div>
    );
};

export const HvaInfo = connect(null, mapDispatchToProps)(HvaInfoComponent);
